import React, { useEffect, useState } from "react";
import _ from "lodash";
import axios from "axios";
import { API_URL } from "../../../utils/Common";
import { Form, Dropdown, Table, Grid } from "semantic-ui-react";
import MyLoader from "../../sharecomponents/MyLoader";

const CatalogoTipoFlores = (props) => {
    const [loader, updateLoader] = useState(false);
    const [flores, setFlores] = useState([]);
    const [tipoFlores, setTipoFlores] = useState([]);

    useEffect(() => {
        getFlores();
        getTipoFlores();
    }, []);

    function getFlores() {
        updateLoader(true)
        axios.get(API_URL + '/flor/getFlores')
            .then(r => {
                const floresDrop = _.map(r.data.flores, (flor, index) => ({ key: flor.id, value: flor.id, text: flor.nombre_comun }));
                setFlores([...floresDrop]);
                updateLoader(false);
            });
    }

    function getTipoFlores() {
        updateLoader(true);
        axios.get(API_URL + '/catalogos/getTipoFlores')
            .then(r => {
                setTipoFlores([...r.data.tiposflor]);
                updateLoader(false);
            });
    }

    return (
        <>
            <div className="w-full p-3 right-0">
                <div className="bg-white border rounded shadow-xl">
                    <div className="border-b rounded-t p-3 bg-orange-900">
                        <h5 className="font-bold uppercase text-white">Tipo de Flores</h5>
                        <p className="text-white text-sm">Catálogo del Tipo de Flor (Flor-Variedad-Color)</p>
                    </div>
                    <div className="p-5 rounded-b">
                        {/* ---- CONTENIDO --- */}
                        <Grid columns={4}>
                            <Grid.Row>
                                <Grid.Column>
                                    <Form>
                                        <Form.Field>
                                            <Dropdown
                                                fluid search
                                                name='florid'
                                                selection options={flores}
                                                placeholder='Filtrar por Flor' />
                                        </Form.Field>
                                    </Form>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        {/** TABLE DE LOS DATOS */}
                        <Table striped celled size='small'>
                            <Table.Header>
                                <Table.Row style={{ textAlign: 'center' }}>
                                    <Table.HeaderCell
                                        style={{ backgroundColor: '#7B341E', color: '#fff', width: '2rem', textAlign: 'center' }}>#</Table.HeaderCell>
                                    <Table.HeaderCell
                                        style={{ backgroundColor: '#7B341E', color: '#fff' }}>
                                        FLOR
                                    </Table.HeaderCell>
                                    <Table.HeaderCell
                                        style={{ backgroundColor: '#7B341E', color: '#fff' }}>VARIEDAD</Table.HeaderCell>
                                    <Table.HeaderCell
                                        style={{ backgroundColor: '#7B341E', color: '#fff' }}>COLOR</Table.HeaderCell>
                                    <Table.HeaderCell
                                        style={{ backgroundColor: '#7B341E', color: '#fff' }}>ACCIONES</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    tipoFlores.map((f, i) => {
                                        return (
                                            <Table.Row key={i}>
                                                <Table.Cell
                                                    style={{ textAlign: 'center' }}>{i + 1}</Table.Cell>
                                                <Table.Cell>{f.flor}</Table.Cell>
                                                <Table.Cell>{f.variedad}</Table.Cell>
                                                <Table.Cell>{f.color}</Table.Cell>
                                                <Table.Cell>

                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })
                                }
                            </Table.Body>
                        </Table>
                    </div>
                </div>
            </div>
            {loader && <MyLoader />}
        </>
    )
}

export default CatalogoTipoFlores;